import { pr, theme } from "aaa";
import * as React from "react";
import * as _ from "lodash";
import { NativePaper } from "components/common/NativePaper";
import { ui } from "components/util/uiHelpers";
import toastSore from "stores/ToastStore";
import { observer } from "mobx-react";

type IToastProps = {
    message: string;
    index: number;
};

export const Toast = ({ message }: IToastProps) => {
    const [isOpen, setIsOpen] = React.useState(true);

    const handleClickClose = () => {
        setIsOpen(false);
    };

    if (!isOpen) {
        return null;
    }

    return (
        <NativePaper
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: theme.BORDER_RADIUS,
                paddingLeft: theme.MARGIN,
                paddingRight: theme.MARGIN,
                marginTop: theme.MARGIN_SMALL,
                width: 300,
                height: 56,
                backgroundColor: theme.themeColors.blue_400,
                boxShadow: `0px 20px 16px -12px ${ui.isDarkMode ? "black" : theme.themeColors.blue_400}`,
            }}
        >
            <pr.HFlexCentered style={{ flex: 1, justifyContent: "space-between" }}>
                <pr.HFlexCentered>
                    <pr.IconCheckmarkCircle style={{ color: "#01B25A" }} />
                    <pr.P_16_CONTENT style={{ color: "#ffffff", marginLeft: theme.MARGIN_SMALL }} aria-live="polite">
                        {message}
                    </pr.P_16_CONTENT>
                </pr.HFlexCentered>
                <pr.IconTimes style={{ color: "#ffffff", cursor: "pointer" }} onClick={handleClickClose} />
            </pr.HFlexCentered>
        </NativePaper>
    );
};

export const ToastList = observer(() => (
    <div
        style={{
            position: "fixed",
            bottom: 40,
            left: ui.isMobile ? "50%" : 40,
            transform: ui.isMobile ? "translate(-50%, 0)" : undefined,
            zIndex: 9000
        }}
        aria-hidden="true"
    >
        {_.reverse([...toastSore.messages]).map((message, index) => (
            <Toast message={message} index={index} key={index} />
        ))}
    </div>
));


// WEBPACK FOOTER //
// ./src/components/common/ToastList.tsx